var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WacomTablet50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#78909C",
    d: "M46,32c0,1.104-0.896,2-2,2H4c-1.104,0-2-0.896-2-2V8c0-1.104,0.896-2,2-2h40c1.104,0,2,0.896,2,2V32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M10 10H42V30H10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M2,10v20h8V10H2z M8,28H4v-4h4V28z M6,22c-1.104,0-2-0.896-2-2s0.896-2,2-2s2,0.896,2,2S7.104,22,6,22z M8,16H4v-4h4V16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M12 12H13V14H12z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M12 12H14V13H12zM36 26H37V28H36z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M35 27H37V28H35zM12 27H14V28H12z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M12 26H13V28H12zM35 12H37V13H35z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M36 12H37V14H36z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#78909C",
    d: "M20.201,20.787c0.391,0.391,0.391,1.023,0,1.414l0,0c-0.391,0.391-1.023,0.391-1.414,0l-1.414-1.414c-0.391-0.391-0.391-1.023,0-1.414l0,0c0.39-0.391,1.023-0.391,1.414,0L20.201,20.787z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#64B5F6",
    d: "M39.293,38.465l-2.828,2.828c0,0-11.314-11.313-12.729-12.728s-3.524-2.133-3.524-2.133l4.231-4.231c0,0,0.707,2.121,2.121,3.536C27.979,27.151,39.293,38.465,39.293,38.465z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E88E5",
    d: "M18.08 21.494L20.201 26.444 24.443 22.201 19.494 20.08z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M40 39.172L40 40.586 38.586 42 37.172 42 36.465 41.293 39.293 38.465z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M27.271,27.858c0.391,0.391,0.391,1.023,0,1.414l0,0c-0.391,0.391-1.023,0.391-1.414,0l-2.121-2.121c-0.391-0.391-0.391-1.024,0-1.414l0,0c0.391-0.391,1.023-0.392,1.414,0L27.271,27.858z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WacomTablet50);
export default __webpack_public_path__ + "static/media/icons8-wacom-tablet-50.e2d7b601c5175d2ed403c0e2a8e3d605.svg";
export { ForwardRef as ReactComponent };